import { render, staticRenderFns } from "./BlogsList.vue?vue&type=template&id=25590e54&"
import script from "./BlogsList.vue?vue&type=script&lang=js&"
export * from "./BlogsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports